/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

const CANDIDATE_ARGS = [undefined, {}, null];

const isNonEmptyArray = (value) => Array.isArray(value) && value.length > 0;

export const normalizeQueryKey = (queryKey) => {
  if (!queryKey) {
    return null;
  }

  if (typeof queryKey === "string") {
    return [queryKey];
  }

  if (isNonEmptyArray(queryKey)) {
    return queryKey;
  }

  return null;
};

export const toBaseQueryKey = (queryKey) => {
  const normalized = normalizeQueryKey(queryKey);
  if (!normalized) {
    return null;
  }

  return [normalized[0]];
};

export const getBaseQueryKey = (queryKeyDefinition) => {
  const directBaseKey = toBaseQueryKey(queryKeyDefinition);
  if (directBaseKey) {
    return directBaseKey;
  }

  if (typeof queryKeyDefinition !== "function") {
    return null;
  }

  for (const arg of CANDIDATE_ARGS) {
    try {
      const resolved = queryKeyDefinition(arg);
      const baseKey = toBaseQueryKey(resolved);
      if (baseKey) {
        return baseKey;
      }
    } catch (_error) {
      // Ignore and try the next candidate.
    }
  }

  return null;
};

export const mergeQueryKeys = (...queryKeyGroups) => {
  const flattened = queryKeyGroups.flat();
  const deduped = new Map();

  flattened.forEach((queryKey) => {
    const baseQueryKey = toBaseQueryKey(queryKey);
    if (!baseQueryKey) {
      return;
    }

    const signature = JSON.stringify(baseQueryKey);
    if (!deduped.has(signature)) {
      deduped.set(signature, baseQueryKey);
    }
  });

  return [...deduped.values()];
};
